import routes from "@/routes";
import { lazy } from "react";
const Billing = lazy(() => import("@/modules/Billing"));
const BillingManagement = lazy(() => import("@/modules/Billing/BillingManagement"));
const Plan = lazy(() => import("@/modules/Billing/Plan"));
const Success = lazy(() => import("@/modules/Billing/Success"));
const Cancel = lazy(() => import("@/modules/Billing/Cancel"));
const SyncStatus = lazy(() => import("@/modules/Billing/SyncStatus"));
const CompleteUpgrade = lazy(() => import("@/modules/Billing/CompleteUpgrade"));
const ContactUs = lazy(() => import("@/modules/Billing/ContactUs"));

const BillingRoutes = {
  element: <Billing />,
  path: routes.BILLING.INDEX,
  children: [
    {
      element: <BillingManagement />,
      path: "",
    },
    {
      element: <Plan />,
      path: routes.BILLING.PLANS,
    },
    {
      element: <Success />,
      path: routes.BILLING.SUCCESS,
    },
    {
      element: <Cancel />,
      path: routes.BILLING.CANCEL,
    },
    {
      element: <SyncStatus />,
      path: routes.BILLING.SYNC_STATUS,
    },
    {
      element: <CompleteUpgrade />,
      path: routes.BILLING.COMPLETE_UPGRADE,
    },
    {
      element: <ContactUs />,
      path: routes.BILLING.CONTACT,
    },
  ],
};

export default BillingRoutes;
